import { defineStore } from "pinia";
import { ref } from "vue";
//@ts-ignore
import { QueryEMX2 } from "molgenis-components";
import useErrorHandler from "../composables/errorHandler";
import { useCollectionStore } from "./collectionStore";
import { useSettingsStore } from "./settingsStore";

const { setError, clearError } = useErrorHandler();

export const useNetworkStore = defineStore("networkStore", () => {
  const settingsStore = useSettingsStore();
  const collectionsStore = useCollectionStore();
  const graphqlEndpoint = settingsStore.config.graphqlEndpoint;
  const dataModel = settingsStore.config.dataModel;

  let networkReport = ref<any>({});

  async function loadNetworkReport(netWorkId: string) {
    clearError();
    const biobanksQuery = new QueryEMX2(graphqlEndpoint)
      .table(dataModel.providerTable)
      .select(["name", "id", "description", "withdrawn"])
      .where("network.id")
      .equals(netWorkId);

    let biobanksResult;
    try {
      biobanksResult = await biobanksQuery.execute();
    } catch (error) {
      setError(Error);
      return;
    }

    const reportQuery = new QueryEMX2(graphqlEndpoint)
      .table(dataModel.networkTable)
      .select(settingsStore.config.networkReportColumns)
      .where("id")
      .equals(netWorkId);

    let networkResult;
    try {
      networkResult = await reportQuery.execute();
    } catch (error) {
      setError(error);
      return;
    }

    // Collections are only part of the collections-era datamodel.
    let collectionsResult;
    if (settingsStore.collectionsViewEnabled) {
      const collectionsColumns =
        collectionsStore.getCollectionColumns() as any;
      const collectionsQuery = new QueryEMX2(graphqlEndpoint)
        .table("Collections")
        .select(collectionsColumns)
        .where("network.id")
        .equals(netWorkId);

      try {
        collectionsResult = await collectionsQuery.execute();
      } catch (error) {
        setError(error);
        return;
      }
    }

    const networks = networkResult?.[dataModel.networkTable];
    if (networks?.length) {
      networkReport.value = {
        network: networks[0],
        biobanks: biobanksResult?.[dataModel.providerTable],
        collections: collectionsResult?.Collections ?? [],
      };
    } else {
      setError("Network not found");
      networkReport.value = {
        network: undefined,
        biobanks: biobanksResult?.[dataModel.providerTable],
        collections: collectionsResult?.Collections ?? [],
      };
    }
  }

  return {
    networkReport,
    loadNetworkReport,
  };
});
